// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.lock-job-btn[data-v-23a45e3a] {\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
